module.exports = __webpack_public_path__ + "static/balloons-828ff467124d175315b6b75c24f6a81c.png";